import { merge } from "lodash";
import { BaseAction } from "@al/aku-lc-core";

import linkTo from "~/common/utils/linkTo";
import { isIos } from "~/common/utils";

import analyzeLink from "../utils/analyzeLink";

import { NeedBeforeExecuteActionOptions } from "./interfaces";

export type LinkToActionPayload = {
  uri: string;
  uriList: string[];
  query?: Record<string, string>;
};

export const linkTarget = (url: string, query?: LinkToActionPayload["query"]): void => {
  const link = url.includes("ak://") ? url : analyzeLink(url, query);
  linkTo(link);
};

export default class LinkToAction extends BaseAction<LinkToActionPayload> {
  onBeforeExecute?: () => boolean | void;

  constructor(options: NeedBeforeExecuteActionOptions<LinkToActionPayload>) {
    super(options);
    this.onBeforeExecute = options.onBeforeExecute;
  }

  execute = async (...args: Array<any>): Promise<void> => {
    if (this.onBeforeExecute?.() === false) {
      return;
    }
    const callbackData = args[args.length - 1];
    if (callbackData) {
      const p = merge({}, this.payload, callbackData);
      this.updatePayload(p);
    }

    const { uri, uriList, query } = this.payload;
    let url = uri;
    if (uriList) {
      url = isIos() ? uriList[1] : uriList[0];
    }
    linkTarget(url, query);

    this.updateStatus("Succeeded");
    this.executeAfterActions();
  };
}
